module.exports = __webpack_public_path__ + "img/PPMP2.0542a438.png";